import en from './creditStrings.en';

export default {
  en,
};
